module.exports = __webpack_public_path__ + "static/media/QR-landing-.d982826d.png";